import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export function useStoreCustomer() {
  var user = useState('useStoreCustomer-user', function () {
    return null;
  });
  var cart = useState('useStoreCustomer-cart', function () {
    return null;
  });
  function setUser(customer) {
    if (!customer) {
      user.value = null;
      return;
    }
    user.value = _objectSpread(_objectSpread({}, customer), {}, {
      // Firstname and lastname can be ',' when user has authenticated with Social login and has no name
      // This is because our RCU does not accept user with empty name
      firstName: customer.firstName && customer.firstName !== ',' ? customer.firstName : '',
      lastName: customer.lastName && customer.lastName !== ',' ? customer.lastName : ''
    });
  }
  function setCart(newCart) {
    cart.value = newCart;
  }
  return {
    user: readonly(user),
    setUser: setUser,
    cart: readonly(cart),
    setCart: setCart
  };
}